<style>
	agm-map {
		height: 300px;
	}
</style>

<form *ngIf="form"
	[formGroup]="form">
	<div class="bk-ranch-dialog-form">
		<div class="left-content-container bk-modal__left">
			<div *ngIf="inEditMode"
				class="bk-form-group bk-ranch-owner-name">
				<label class="bk-modal__label">
					{{'Ranch Owner' | translate }}
				</label>
				<div>
					{{ranchOwnerFullName}}
				</div>
			</div>

			<mat-form-field appearance="fill"
				class='mat-form-field--one-line mat-form-field--short'>
				<mat-label for="ranch-name">
					{{'Ranch Name' | translate }}
				</mat-label>
				<input matInput
					id="ranch-name"
					formControlName="Name"
					required
					type="text">
				<mat-error *ngIf="f.Name.invalid && (f.Name.dirty || f.Name.touched)">
					{{'Ranch name cannot be empty' | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field appearance="fill"
				class='mat-form-field--one-line mat-form-field--short'>
				<mat-label>
					{{'Coordinates' | translate }}
				</mat-label>
				<input matInput
					id="coordinates"
					type="text"
					formControlName="Coordinates"
					required>
				<mat-hint align="start">{{ 'coordinates format text' | translate }}</mat-hint>
				<mat-error *ngIf="f.Coordinates.invalid && (f.Coordinates.dirty || f.Coordinates.touched)">
					<span *ngIf="f.Coordinates.errors.coordinatesTooLong">
						{{'coordinates should contain 6 or less decimals' | translate }}
					</span>
					<span *ngIf="f.Coordinates.errors.coordinatesInvalid">
						{{'Invalid coordinates' | translate }}
					</span>
				</mat-error>
			</mat-form-field>

			<div *ngIf="coordinateExplanation"
				class="bk-clearfix bk-location-warning">
				<i class="fa fa-warning"></i>
				{{ coordinateExplanation }}
			</div>

			<mat-form-field appearance="fill"
				class='mat-form-field--one-line mat-form-field--short'>
				<mat-label>
					{{'Acres' | translate }}
				</mat-label>
				<input matInput
					formControlName="Acres"
					step="0.01"
					required
					type="number">
				<span matSuffix class="mat-form-field-suffix--padded">
					{{'acres' | translate }}
				</span>
				<mat-error *ngIf="f.Acres.invalid && (f.Acres.dirty || f.Acres.touched)">
					<ng-container *ngIf="f.Acres.errors.required">
						{{ 'Field is required' | translate }}
					</ng-container>
					<ng-container *ngIf="f.Acres.errors.min">
						{{ 'Acres must be greater than zero' | translate }}
					</ng-container>
					<ng-container *ngIf="f.Acres.errors.max">
						{{'Acres must be less than 10,000' | translate }}
					</ng-container>
				</mat-error>
			</mat-form-field>
		</div>

		<div class="bk-modal__right"
			[class.bk-modal__shown]="!loadingData">
			<div *ngIf="!inEditMode"
				class="bk-modal__right-instructions">
				{{'Ranch map instructions' | translate }}
			</div>
			<div class="bk-modal__right-instructions">
				<div class="bk-marker bk-marker--ranch">
					<svg-ranch-marker></svg-ranch-marker>
				</div>
				{{'Ranch' | translate }}
			</div>
			<div class="bk-modal__map-container map-container">
				<agm-map (mapReady)="mapReady()"
					(mapClick)="changeCoordinatesMap($event)"
					[mapTypeId]="'hybrid'"
					[fullscreenControl]="true">
					<agm-marker *ngFor="let marker of markers"
						[iconUrl]="'../assets/images/icons/map_marker-ranch-v2.png'"
						[latitude]="marker.lat"
						[longitude]="marker.lng">
					</agm-marker>
					<map-control></map-control>
				</agm-map>
			</div>
		</div>
	</div>
</form>
